<div class="ui-g-12 ui-md-6">
  <h2>{{ 'balance.customerBalances' | translate }}</h2>
  <p>{{ 'balance.customer' | translate }}</p>
  <input style="width: 100%;" type="text" pInputText class="fieldInput" [(ngModel)]="customer" disabled/>
</div>
<div class="ui-g-12 ui-md-6" style="text-align: right;">
  <button pButton class="k-generic-btn" type="button" icon="fa fa-arrow-left" iconPos="left" [routerLink]="'/customers-infosheet-new'" label="{{ 'common.back' | translate }}"></button>
</div>
<div class="ui-g-12">
  <app-kontable
    #table
    *ngIf="balances.length > 0"
    title="{{ 'balance.balances' | translate }}"
    [columns]="[
      {field: 'card_no', title: 'balance.cardNo'},
      {field: 'acm_desc', title: 'balance.acm'},
      {field: 'value', title: 'reservations.points'}
    ]"
    [source]="balances"
    [showRecoverButton]="false"
    [showInfoButton]="false"
    [showAddButton]="false"
    [showDeleteButton]="false"
    [showDetailsButton]="false"
    [showEditButton]="false"
    [showReport]="true"
    [showGlobalFilter]="false"
    [additionalRowCommands]="customRow"
  >
    <ng-template #customRow data-testid="customRow" let-row>
      <!-- Button per Prenotazione Premi -->
      <p-button *ngIf="this.catalogVisible && divisionId && !acmExpired(row.date_end) && row.value > 0" pTooltip="{{ 'balance.giftReservation' | translate }}" icon="fa fas fa-gift" styleClass="ui-button-info" (click)="goToGiftReservation(row)"></p-button>
      <!-- Button Prenotazioni Aperte  -->
      <p-button  pTooltip="{{ 'balance.activeReservations' | translate }}" icon="fa fas fa-unlock" styleClass="ui-button-info" (click)="goToReservations(row, 'active')"></p-button>
      <!-- Button Prenotazione Chiuse -->
      <p-button  *ngIf="!acmExpired(row.date_end)" pTooltip="{{ 'balance.closedReservations' | translate }}" icon="fa fas fa-lock" styleClass="ui-button-info" (click)="goToReservations(row, 'closed')"></p-button>
    </ng-template>
  </app-kontable>
</div>



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-balance/loyalty-balance.component.html